import {
  DownloadData,
  Resource,
} from "@/redux/resources/types/Resources.interface";
import { api } from "./instance";

const _resourceService = {
  getInvoicePDF: async (downloadData: DownloadData) => {
    const response = await api.post<Resource>(
      `ssh-resources/pdf`,
      downloadData,
    );
    return response.data;
  },
  getResourcesPDF: async (nroInterno: string) => {
    const response = await api.post<Resource>(
      `ssh-resources/tiff/${nroInterno}`,
    );
    return response.data;
  },
};

export default _resourceService;
